export default "__VITE_ASSET__CkHsHQOC__"